import { render, staticRenderFns } from "./TaskMoneyConfigmainliulan.vue?vue&type=template&id=15e1a6ca&"
import script from "./TaskMoneyConfigmainliulan.vue?vue&type=script&lang=js&"
export * from "./TaskMoneyConfigmainliulan.vue?vue&type=script&lang=js&"
import style0 from "./TaskMoneyConfigmainliulan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports